module.exports = __webpack_public_path__ + "static/doordash-logo-8282e955034a598fc89811dd980658a0.png";